import CartActionTypes from './cart.types'

export const toggleCartHidden = () => ({
    type: CartActionTypes.TOGGLE_CART_HIDDEN,
})

export const toggleCloseCart = () => ({
    type: CartActionTypes.TOGGLE_CLOSE_CART,
})

export const addCake = item => ({
    type: CartActionTypes.ADD_CAKE,
    payload: item
})

export const removeCake = item => ({
    type: CartActionTypes.REMOVE_CAKE,
    payload: item
})

export const addItem = item => ({
    type: CartActionTypes.ADD_ITEM,
    payload: item
})

export const clearItemFromCart = item => ({
    type: CartActionTypes.CLEAR_ITEM_FROM_CART,
    payload: item
})

export const removeItem = item => ({
    type: CartActionTypes.REMOVE_ITEM,
    payload: item
})

export const emptyCart = () => ({
    type: CartActionTypes.EMPTY_CART,
})

export const submitUserInfo = item => ({
    type: CartActionTypes.SUBMIT_USER_INFO,
    payload: item
})

export const submitPaymentMethod = item => ({
    type: CartActionTypes.SUBMIT_PAYMENT_METHOD,
    payload: item
})